import { Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const InspectorConstraintResolutionRecord = Record({
  id: "",
  label: "",
  offset: ""
});

const data = {};
createFromJS.registerCallback(
  "InspectorConstraintResolutionRecord",
  createFromJS.createNestedCallback(InspectorConstraintResolutionRecord, data)
);
